var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.90822 1.71863C8.82622 0.0866289 11.1746 0.0866289 12.0914 1.71863L18.7874 13.6226C19.6874 15.2234 18.5318 17.1986 16.697 17.1986H3.30382C1.46782 17.1986 0.312218 15.2234 1.21222 13.6226L7.90822 1.71863ZM11.1998 13.5998C11.1998 13.9181 11.0734 14.2233 10.8483 14.4484C10.6233 14.6734 10.3181 14.7998 9.99982 14.7998C9.68156 14.7998 9.37633 14.6734 9.15129 14.4484C8.92625 14.2233 8.79982 13.9181 8.79982 13.5998C8.79982 13.2816 8.92625 12.9763 9.15129 12.7513C9.37633 12.5263 9.68156 12.3998 9.99982 12.3998C10.3181 12.3998 10.6233 12.5263 10.8483 12.7513C11.0734 12.9763 11.1998 13.2816 11.1998 13.5998ZM9.99982 3.99983C9.68156 3.99983 9.37633 4.12626 9.15129 4.3513C8.92625 4.57634 8.79982 4.88157 8.79982 5.19983V8.79983C8.79982 9.11809 8.92625 9.42331 9.15129 9.64836C9.37633 9.8734 9.68156 9.99983 9.99982 9.99983C10.3181 9.99983 10.6233 9.8734 10.8483 9.64836C11.0734 9.42331 11.1998 9.11809 11.1998 8.79983V5.19983C11.1998 4.88157 11.0734 4.57634 10.8483 4.3513C10.6233 4.12626 10.3181 3.99983 9.99982 3.99983Z",
    fill: "#FFBB1D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarnIcon);
export default __webpack_public_path__ + "static/media/warnIcon.16beb033c584ad8e318c68cfd876c89a.svg";
export { ForwardRef as ReactComponent };